import React from "react";
import SvgIcon from "../../../Icons/SvgIcon";
import {
  IDropdownButtonTextProps,
  ILangOption,
} from "../Select/Select.interface";

export default function LanguageSwitcherButton({
  hasSelectedValue,
  placeholder = "",
  selected,
}: IDropdownButtonTextProps<ILangOption>): JSX.Element {
  if (!hasSelectedValue) return placeholder as JSX.Element;

  return (
    <div
      className="d-flex align-items-center"
      data-testid="LanguageSwitcherButton"
    >
      <SvgIcon icon={selected.icon} classes={{ root: "me-5" }} />
      {selected.label}
    </div>
  );
}
